module.exports = __webpack_public_path__ + "img/arrow-green.03df72ba.svg";